import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportDriverActivitiesCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'
import { ExportUnknownDriverLocations } from '../components/ExportsSettings/ExportUnknownDriverLocations'

export function ExportActivities() {
  const translations = useTranslate({
    activities: 'common.activities',
  })

  return (
    <ExportSection header={translations.activities}>
      <ExportDriverActivitiesCard />

      <ExportUnknownDriverLocations />
    </ExportSection>
  )
}
